import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseHttpService } from './base-http.service';
import { AuthResponse } from '../interfaces/auth.interface';
import { 
  InsuranceCompany, 
  CreateInsuranceCompanyRequest, 
  UpdateInsuranceCompanyRequest 
} from '../interfaces/insurance-company.interface';
import { API_ENDPOINTS } from '../constants/api.constants';

/**
 * Service for insurance company management operations
 */
@Injectable({
  providedIn: 'root'
})
export class InsuranceCompaniesService extends BaseHttpService {

  /**
   * Gets all insurance companies
   */
  getAllInsuranceCompanies(): Observable<InsuranceCompany[]> {
    if (!this.hasValidToken()) {
      return this.returnEmptyArrayWhenNoToken<InsuranceCompany>();
    }
    return this.get<InsuranceCompany[]>(API_ENDPOINTS.AUTH.INSURANCE_COMPANIES);
  }

  /**
   * Creates a new insurance company
   */
  createInsuranceCompany(insuranceCompany: CreateInsuranceCompanyRequest): Observable<AuthResponse & { id?: number }> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken('Nincs érvényes token');
    }
    return this.post<AuthResponse & { id?: number }>(API_ENDPOINTS.AUTH.INSURANCE_COMPANIES, insuranceCompany);
  }

  /**
   * Updates an existing insurance company
   */
  updateInsuranceCompany(id: number, insuranceCompany: UpdateInsuranceCompanyRequest): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken('Nincs érvényes token');
    }

    const endpoint = `${API_ENDPOINTS.AUTH.INSURANCE_COMPANIES}/${id}`;
    return this.put<AuthResponse>(endpoint, insuranceCompany);
  }

  /**
   * Deletes an insurance company
   */
  deleteInsuranceCompany(id: number): Observable<AuthResponse> {
    if (!this.hasValidToken()) {
      return this.returnErrorWhenNoToken('Nincs érvényes token');
    }

    const endpoint = `${API_ENDPOINTS.AUTH.INSURANCE_COMPANIES}/${id}`;
    return this.delete<AuthResponse>(endpoint);
  }
}